<template>
  <section class="colored section">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(validateBeforeSubmit)">
        <h2 class="title">{{ $t('4 Subir archivos') }}</h2>
        <h3>
          (doc, docx, .xls, .xlsx, .pdf, .zip, .rar, .mp4, .png, .jpg)
        </h3>
        <br />

        <b-field
          v-if="rol == 'corporative_director'"
          expanded
          label-position="on-border"
          :label="$t('Enlace para compartir')"
        >
          <b-input expanded :value="shareLink"></b-input>
          <p class="control">
            <b-button @click="copyShareLink" class="button is-primary">{{
              $t('Copiar')
            }}</b-button>
          </p>
        </b-field>

        <table class="table  is-striped is-narrow is-hoverable is-fullwidth">
          <file-input
            icon="upload"
            :text="$t('Presentación corporativa de la empresa')"
            v-model="formData.companyPresentation"
          />

          <file-input
            icon="upload"
            :text="
              $t(
                'Pitch deck, investor deck, business plan del proyecto o memorándum ejecutivo'
              )
            "
            v-model="formData.pitchDeck"
          />

          <file-input
            icon="upload"
            :text="
              $t(
                'Dos últimas auditorías o impuestos de sociedades anuales presentados en vigor'
              )
            "
            v-model="formData.lastAudits"
          />

          <file-input
            icon="upload"
            :text="
              $t(
                'Balance de situación y cuentas de explotación actualizadas (del año en curso)'
              )
            "
            v-model="formData.accountBalance"
          />

          <file-input
            icon="upload"
            :text="
              $t(
                'Pool financiero en vigor actualizado (detallado por institución, tipo de deuda e importe)'
              )
            "
            v-model="formData.financialPool"
          />

          <file-input
            icon="upload"
            :text="
              $t(
                'Listado de principales clientes (detallado de negocio anual por cliente)'
              )
            "
            v-model="formData.mainClientsList"
          />

          <file-input
            icon="upload"
            :text="$t('Otros documentos de interés mercantil')"
            v-model="formData.otherMerchantDocuments"
          />

          <file-input
            icon="upload"
            :text="$t('Otros hechos relevantes en su actividad')"
            v-model="formData.otherActivityDocuments"
          />

          <file-input
            icon="upload"
            :text="$t('Requerimiento de información adicional')"
            v-model="formData.aditionalInfoDocuments"
          />
          <file-input
            icon="upload"
            :text="$t('Otros archivos')"
            v-model="formData.otherFiles"
          />
        </table>

        <b-field
          expanded
          :label="$t('Enlace para descargar información solicitada de la nube')"
        >
          <b-input
            expanded
            v-model="formData.cloudInfoLink"
            placeholder="OneDrive / Drive / Dropbox / Amazon / .."
          ></b-input>
        </b-field>
        <div class="has-text-centered">
          <b-button size="is-large" native-type="submit" type="is-primary">{{
            $t('Guardar')
          }}</b-button>
          <b-button
            @click="terminate"
            size="is-large"
            style="margin-left: 5px;"
            type="is-primary"
            >{{ $t('Terminar') }}</b-button
          >
        </div>
      </form>
    </ValidationObserver>
  </section>
</template>
<script>
import { ValidationObserver } from 'vee-validate'
import BulmaS3UploadInput from '@/components/common/BulmaS3UploadInput'
import MD5 from 'crypto-js/md5'
import { mapGetters } from 'vuex'
export default {
  components: {
    ValidationObserver,
    FileInput: BulmaS3UploadInput
  },
  props: {
    id: {
      type: String,
      required: true
    },
    requestFiles: {
      type: Object,
      default: function() {
        return {
          companyPresentation: [],
          pitchDeck: [],
          lastAudits: [],
          accountBalance: [],
          financialPool: [],
          mainClientsList: [],
          otherMerchantDocuments: [],
          otherActivityDocuments: [],
          aditionalInfoDocuments: [],
          cloudInfoLink: null,
          otherFiles: []
        }
      }
    }
  },
  requestFiles: function(val) {
    this.formData = val
  },
  watch: {
    requestFiles: function(val) {
      this.formData = val
    }
  },
  computed: {
    ...mapGetters('user', ['rol']),
    shareLink() {
      return (
        window.location.protocol +
        '//' +
        window.location.host +
        '/shared-docs/' +
        this.id +
        '?token=' +
        MD5(this.id + 'ecobanka').toString()
      )
    }
  },
  data() {
    return {
      infoLink: null,
      testFile: null,
      isCardModalActive: false,
      formData: {}
    }
  },
  beforeMount() {
    this.formData = this.requestFiles
  },
  methods: {
    copyShareLink() {
      navigator.clipboard.writeText(this.shareLink)
    },
    validateBeforeSubmit() {
      this.$emit('formSubmit', { requestFiles: this.formData })
    },
    terminate() {
      this.$emit('terminate')
    }
  }
}
</script>

<style scoped>
p.squared {
  border: 1px;
  border-style: solid;
  border-color: #8c67ef;
}
</style>
